<template>
	<div>
		<div class="TopSearch">
			<FromComm :FromArr="FromArr"></FromComm>
			<div class="btngroup">
				<CommonBtngroup ref="btngroup" :qhide="false" @select="handSearch" @reset="handReset"></CommonBtngroup>
			</div>
		</div>
		<div class="ContentView_CheckVouch">
			<div class="BottomTable">
				<Commonbtn v-if="auth.includes('add')" backgroundColor="#FFF" title="刷新" fontSize="14px"
					@btnclick="handRefresh" :src="require('@/assets/icon/shua.png')" />
				<Commonbtn backgroundColor="#FFF" title="导出" fontSize="14px" @btnclick="handExport"
					:src="require('@/assets/icon/daoc.png')" />
			</div>
			<div class="custom-table">
				<el-table ref="tableRef" :data="tableData" style="width: 100%;" tooltip-effect="dark">
					<el-table-column prop="Warehouse" show-overflow-tooltip label="仓库" width="180" />
					<el-table-column prop="CreateTime" label="上报时间" width="180" />
					<el-table-column prop="InvAddCode" label="产品型号" width="180" />
					<el-table-column prop="InvName" show-overflow-tooltip label="产品名称" width="180" />
					<el-table-column prop="InvClassName" label="产品线" width="120" />
					<el-table-column prop="ReservationQuantity" label="在途数量" width="80" />
					<el-table-column prop="Batch" label="批号" width="120" />
					<el-table-column prop="Unit" label="包装单位" width="80" />
					<el-table-column prop="ManuDate" show-overflow-tooltip label="生产日期" width="130" />
					<el-table-column prop="ValiDate" show-overflow-tooltip label="效期" width="130" />
					<el-table-column prop="Quantity" label="库存数量" width="80" />
					<el-table-column prop="BarCode" show-overflow-tooltip label="条码" width="180" />
					<el-table-column prop="InvUniqueCode" label="序列号" width="120" />
				</el-table>
			</div>
			<div class="pagination">
				<Pagination ref="invPagination" type='allColor' :pageSize="query.pageSize"
					@handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange" :total="total">
				</Pagination>
			</div>
		</div>
	</div>
</template>

<script>
	import FromComm from '../../../views/home/components/fromComponents/Commfrom/from-comm.vue'
	import CommonBtngroup from '../../../../components/commongroup.vue'
	import Commonbtn from '../../../../components/common-btn.vue'
	import Pagination from '../../../../components/pagination.vue'
	import Commontable from '../../../../components/common-table.vue'
	import FromArr from './FormData/FromArr'
	import utils from '../../../../common/utils'
	import DialogFrom from '../../../../components/dialog-from.vue'
	import Commondropdownlist from '../../../../components/common-dropdownlist.vue'
	import {
		GetUniqueStockByCustomerList,
		GetUniqueStockOrganizationList,
		ExportUniqueStockByCustomer,
		RefreshUniqueStock
	} from '@/api/newsapi'
	import {
		InventoryClassList
	} from '@/api/home'
	export default {
		props: {
			auth: Array
		},
		components: {
			FromComm,
			CommonBtngroup,
			Commonbtn,
			Pagination,
			Commontable,
			DialogFrom,
			Commondropdownlist
		},
		computed: {
			cusCode() {
				return this.$store.state.MenusData.CusCode;
			}
		},
		data() {
			return {
				total: 0,
				query: {
					pageIndex: 1,
					pageSize: 10
				},
				FromArr: [],
				tableData: [],
				dialogVisible: false,
			}
		},
		mounted() {
			this.init();
		},
		methods: {
			init() {
				this.FromArr = JSON.parse(JSON.stringify(FromArr))
				this.InventoryClassList();
				if (this.cusCode) {
					this.query.CompanyID = this.cusCode;
					this.FromArr.splice(4, 1);
					this.getData();
				} else {
					this.getOrderCustomer();
				}
			},
			//查询列表数据
			async getData() {
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				this.query.InvClass = this.FromArr[0].modelvalue;
				this.query.InvUniqueCode = this.FromArr[1].modelvalue;
				this.query.Inventory = this.FromArr[2].modelvalue;
				this.query.Batch = this.FromArr[3].modelvalue;
				if (this.FromArr.length == 5) {
					this.query.CompanyID = this.FromArr[4].modelvalue;
				}
				let {
					code,
					data,
					message
				} = await GetUniqueStockByCustomerList(this.query)
				if (code == 0) {
					this.total = data.Count;
					this.tableData = data.data;
					loading.close();
				} else {
					loading.close();
					this.$message.error(message);
				}
			},
			// 产品线下拉
			async InventoryClassList() {
				let {
					code,
					data
				} = await InventoryClassList({});
				if (code == 0) {
					this.FromArr[0].options = []
					data.data.map((item, index) => {
						this.FromArr[0].options.push({
							key: item.InvClass,
							value: item.InvClassName
						})
					})
				}
			},
			// 经销商下拉
			async getOrderCustomer() {
				let {
					code,
					data
				} = await GetUniqueStockOrganizationList({});
				if (code == 0) {
					this.FromArr[4].options = []
					data.map((item, index) => {
						this.FromArr[4].options.push({
							key: item.Value,
							value: item.Text
						})
					})
					this.FromArr[4].modelvalue = '';
				}
			},
			//刷新数据
			async handRefresh(file) {
				if (!this.query.CompanyID) {
					this.$message.error('未传入经销商');
					return;
				}
				const loading = this.$loading({
					lock: true,
					text: '正在刷新...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					data,
					code,
					message
				} = await RefreshUniqueStock({
					CompanyID: this.query.CompanyID
				});
				if (code == 0) {
					this.$message.success('刷新成功');
					this.getData();
				} else {
					if (data && data.length) {
						this.$alert(`${data.join('<br/>')}`, '提示', {
							dangerouslyUseHTMLString: true,
							showConfirmButton: false
						});
					} else {
						this.$message.error(message);
					}
				}
				loading.close();
			},
			async handExport(e) {
				const loading = this.$loading({
					lock: true,
					text: '正在导出...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				this.query.InvClass = this.FromArr[0].modelvalue;
				this.query.InvUniqueCode = this.FromArr[1].modelvalue;
				this.query.Inventory = this.FromArr[2].modelvalue;
				this.query.Batch = this.FromArr[3].modelvalue;
				if (this.FromArr.length == 5) {
					this.query.CompanyID = this.FromArr[4].modelvalue;
				}
				let resexprot = await ExportUniqueStockByCustomer(this.query)
				loading.close();
				if (resexprot) {
					let date = new Date()
					let str = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}-${date.getTime()}`
					utils.downloadFile(resexprot, `唯一码库存上报-接口版${str}`, "xlsx")
				} else {
					// 返回json
					this.$message.warning('导出失败');
				}
			},
			handSearch() {
				this.query.pageIndex = 1;
				this.getData();
			},
			handReset() {
				this.query = {
					pageIndex: 1,
					pageSize: 10
				};
				this.init();
			},
			handleCurrentChange(e) {
				this.query.pageIndex = e
				this.getData()
			},
			handleSizeChange(e) {
				this.query.pageSize = e
				this.getData()
			}
		},
	}
</script>

<style lang="less" scoped>
	.TopSearch {
		height: 120px;
		margin: 0px 0px 8px;
		background: #FFFFFF;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);

		.btngroup {
			// border: 1px solid #0b65ec;
			position: relative;
			//bottom: 21px;
		}
	}

	.ContentView_CheckVouch {
		background: #FFFFFF;

		.BottomTable {
			padding: 10px 0px;
		}

		.ativte {
			border: 1px solid red;
			color: #e71d43;
			background-color: #fce8ec;
			transition: 0.2s linear;
		}

		.incenters {
			padding: 14px 4px;

			div {
				margin-left: 8px;
				margin-right: 8px;
				margin-top: 5px;
				margin-bottom: 5px;
				// width: 100%;
			}
		}

		.topstate {
			width: 100px;
			height: 32px;
			font-size: 14px;
			border: 1px solid #e6e6e6;
			line-height: 32px;
			text-align: center;
			cursor: pointer;
			display: inline-block;
			user-select: none;
		}

		.custom-table {
			padding: 0px 0px 24px 0px;

			/deep/.el-table .el-table__cell {
				padding: 8px 0;

				.cell {
					.update_ipt {
						.el-input__inner {
							height: 28px;
							line-height: 28px;
							border-radius: 0px;
						}

						.el-input__inner:focus {
							border-color: #e71d43;
						}
					}

					.table-export {
						color: #e71d43;
						cursor: pointer;
					}
				}
			}

			/deep/.el-table th.el-table__cell {
				background: #F3F3F3;
			}

			// /deep/.el-table__body {
			// 	td {
			// 		padding: 0px 0 !important;
			// 		cursor: pointer;
			// 	}
			// }
		}

	}

	.from-table {
		//padding: 0px 24px 24px 24px;

		/deep/.el-table .el-table__cell {
			padding: 8px 0;
		}

		/deep/.el-table th.el-table__cell {
			background: #F3F3F3;
		}
	}
</style>